var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"32px","height":"32px","background-color":"#f0f2f5","text-align":"center","border-radius":"50%"}},[_c('a-icon',{staticStyle:{"font-size":"20px","color":"#5e98e3","margin":"6px 0","cursor":"pointer"},attrs:{"theme":"filled","type":_vm.type},on:{"click":e => _vm.$emit('click', e)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }